module.exports = __webpack_public_path__ + "static/media/time-empty.94b66e76.png";